import { useTranslation } from "react-i18next";

import { Group, Text } from "@mantine/core";

import { useFormatters } from "@prostocheck/i18n";
import { Button } from "@prostocheck/ui";

import { ZReportsTable } from "../z-reports-table";
import { IZReportsPanelProps } from "./z-reports-panel.models";

export const ZReportsPanel = ({
  reports,
  range,
  onSelectReport,
  onOpenPeriodReport,
}: IZReportsPanelProps) => {
  const { t } = useTranslation();
  const { formatDate } = useFormatters();

  return (
    <div>
      {/* `mih` matches the button's height so this row stays the same height
          as the Чеки tab's (which has no button here) — otherwise switching
          tabs shifts the table below. */}
      <Group justify="space-between" align="center" mih="2.75rem" mb="md">
        <Text size="sm" c="dimmed">
          {t("register.periodRange", {
            from: formatDate(range.from),
            to: formatDate(range.to),
          })}
        </Text>
        <Button variant="secondary" onClick={onOpenPeriodReport}>
          {t("register.periodReport")}
        </Button>
      </Group>

      <ZReportsTable reports={reports} onSelectReport={onSelectReport} />
    </div>
  );
};
